"use client";

import React from "react";
import ShoppingCartIcon from "@heroicons/react/24/outline/ShoppingCartIcon";
import RightSidebar from "../RightSidebar/RightSidebar";
import {useCommerceContext} from "provider/magento/context";
import {useLayoutContext} from "../context";

const CartButton = ({store,storeCode,label,_t}) => {

    const {cart} = useCommerceContext();
    const {displaySidebar,closeSidebar,openSidebar} = useLayoutContext();

    return <>
        <div className={'ml-3'}>
            <button aria-label={label} title={label}  onClick={displaySidebar ? closeSidebar : openSidebar}
                    className={'flex relative cursor-pointer'}>
                <span><ShoppingCartIcon className={'w-5 h-5 mr-1'}/></span>
                <span className={'text-sm  hidden xl:block'}>{label}</span>
                {(cart && cart?.items_qty && cart?.items_qty > 0) ?
                    <div className={'rounded-full flex justify-center items-center bg-[#E7BB43] absolute top-[-10px] left-[12px] w-4 h-4 text-[10px]'}>{cart.items_qty}</div> : ''}

            </button>
        </div>
        <RightSidebar store={store} storeCode={storeCode} isOpen={displaySidebar} closeSidebar={closeSidebar} _t={_t}/>
    </>
}

export default CartButton;